package org.teddapp.project.ui.notes

import androidx.compose.foundation.layout.height

import org.teddapp.project.ui.teddOverlayShadow

import org.teddapp.project.ui.teddClickable

import org.teddapp.project.ui.teddCardShadow

import org.teddapp.project.ui.TeddVisibilityBadge

import org.teddapp.project.ui.TeddVisibility

import org.teddapp.project.ui.TeddEmptyState

import org.teddapp.project.ui.TeddIconButton

import org.teddapp.project.ui.TeddIcon

import org.teddapp.project.ui.TeddSize

import org.teddapp.project.ui.TeddSpace

import androidx.compose.ui.text.style.TextOverflow

import androidx.compose.ui.graphics.Color

import androidx.compose.foundation.layout.size

import androidx.compose.foundation.border

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.mikepenz.markdown.compose.components.markdownComponents
import com.mikepenz.markdown.compose.elements.MarkdownCheckBox
import com.mikepenz.markdown.m3.Markdown
import com.mikepenz.markdown.model.MarkdownAnnotator
import com.mikepenz.markdown.model.markdownAnnotator
import org.intellij.markdown.MarkdownTokenTypes
import org.intellij.markdown.ast.getTextInNode
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.withLink
import com.mikepenz.markdown.m3.markdownColor
import com.mikepenz.markdown.m3.markdownTypography
import com.tedd.db.Note
import org.teddapp.project.ui.skills.parseTags
import org.teddapp.project.db.TeddRepositories
import org.teddapp.project.ui.TeddButton
import org.teddapp.project.ui.TeddButtonKind
import org.teddapp.project.ui.TeddButtonSize
import org.teddapp.project.ui.TeddDates
import org.teddapp.project.ui.settings.SettingsDrawerHost
import org.teddapp.project.ui.settings.rememberSettingsDrawer
import org.teddapp.project.ui.TeddTokens
import org.teddapp.project.ui.TeddType
import org.teddapp.project.ui.adaptive.WindowClass
import org.teddapp.project.ui.adaptive.WithWindowClass
import org.teddapp.project.ui.nav.PillarTabs
import org.teddapp.project.ui.nav.NavIntent
import org.teddapp.project.ui.nav.Section
import org.teddapp.project.ui.nav.TeddNavRail
import org.teddapp.project.ui.projects.ProjectsConfirmDelete
import org.teddapp.project.ui.nav.TeddBottomNav
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.ime
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.foundation.layout.union
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import org.teddapp.project.ui.TeddTab
import org.teddapp.project.ui.TeddTabs
import org.teddapp.project.ui.projects.MenuAction
import org.teddapp.project.ui.projects.ProjectMoreMenu
import androidx.compose.foundation.layout.Spacer

/**
 * Notes : ce qu'on écrit pour soi, rangé en carnets ou libre.
 *
 * Un seul écran pour toutes les tailles. Sur grand écran, les carnets à gauche, la
 * liste au milieu, la note ouverte à droite. Sur téléphone, la liste puis la note,
 * l'une après l'autre.
 *
 * Le texte s'enregistre tout seul : une note qu'il faut penser à sauver est une note
 * qu'on perd. Une note supprimée passe 30 jours dans la corbeille avant de disparaître.
 */
@Composable
fun NotesScreen(
    repos: TeddRepositories,
    onNavigate: (Section) -> Unit = {},
    modifier: Modifier = Modifier,
) {
    val model = rememberNotesModel(repos)
    Box(modifier = modifier.fillMaxSize()) {
        WithWindowClass(modifier = Modifier.fillMaxSize()) { wc ->
            when (wc) {
                WindowClass.Compact -> NotesCompact(model, onNavigate)
                else -> NotesExpanded(model, onNavigate)
            }
        }
        org.teddapp.project.ui.TeddSnackbarHost(model.snackbar)
    }
    if (model.creatingBook) {
        BookDialog(
            title = model.creatingUnderName()?.let { "Nouveau dossier dans « $it »" } ?: "Nouveau carnet",
            book = null,
            onConfirm = { name, icon, color -> model.createBook(name, icon, color) },
            onClose = { model.creatingBook = false; model.creatingUnder = null },
        )
    }
    model.confirmDelete?.let { note ->
        ProjectsConfirmDelete(
            title = "Supprimer la note ?",
            itemName = note.title.orEmpty().ifBlank { "Sans titre" },
            description = "Elle part dans la corbeille, d'où tu peux la restaurer pendant 30 jours.",
            onCancel = { model.confirmDelete = null },
            onConfirm = { model.deleteNote(note) },
        )
    }
    model.confirmForget?.let { note ->
        ProjectsConfirmDelete(
            title = "Supprimer définitivement ?",
            itemName = note.title.orEmpty().ifBlank { "Sans titre" },
            description = "La note ne pourra plus être restaurée.",
            onCancel = { model.confirmForget = null },
            onConfirm = { model.forgetNote(note) },
        )
    }
    if (model.confirmEmptyTrash) {
        val n = model.trash.size
        ProjectsConfirmDelete(
            title = "Vider la corbeille ?",
            itemName = if (n > 1) "$n notes" else "1 note",
            description = "Ces notes ne pourront plus être restaurées.",
            onCancel = { model.confirmEmptyTrash = false },
            onConfirm = { model.emptyTrash() },
        )
    }
    model.viewing?.let { (_, id, _) ->
        NoteImageViewer(model.db, id, onRemove = model::removeViewedImage, onClose = { model.viewing = null })
    }
    model.drawing?.let { session ->
        org.teddapp.project.ui.notes.ink.InkEditor(
            initial = session.initial,
            budget = session.budget,
            onSave = { model.saveDrawing(session, it) },
            onDelete = { model.deleteDrawing(session) },
            onClose = { model.closeDrawing(session, it) },
            onReadText = if (org.teddapp.project.ui.notes.ink.HandwritingReader.available) {
                { d, text, replace -> model.placeReadText(session, d, text, replace) }
            } else null,
        )
    }
    model.renamingBook?.let { book ->
        BookDialog(
            title = "Modifier le carnet",
            book = book,
            onConfirm = { name, icon, color -> model.updateBook(book, name, icon, color) },
            onDelete = { model.deleteBook(book) },
            onSub = { model.renamingBook = null; model.creatingUnder = book.id; model.creatingBook = true },
            onClose = { model.renamingBook = null },
        )
    }
}

/** Les carnets : 232 dp par défaut, de 180 à 360. */
private val BOOKS_PANE = org.teddapp.project.ui.PaneSpec("notes.books", default = 232.dp, min = 180.dp, max = 360.dp, collapseBelow = 140.dp)

/** La liste des notes : 320 dp par défaut, de 240 à 520. */
private val NOTES_LIST_PANE = org.teddapp.project.ui.PaneSpec("notes.list", default = 320.dp, min = 240.dp, max = 520.dp)

@Composable
private fun NotesExpanded(model: NotesModel, onNavigate: (Section) -> Unit) {
    val drawer = rememberSettingsDrawer()
    SettingsDrawerHost(drawer, onNavigate = onNavigate) { NotesExpandedContent(model, onNavigate, drawer::open) }
}

@Composable
private fun NotesExpandedContent(model: NotesModel, onNavigate: (Section) -> Unit, onSettings: () -> Unit) {
    org.teddapp.project.ui.RecompositionProbe("notes.expanded")
    Row(modifier = Modifier.fillMaxSize().background(TeddTokens.Bg)) {
        TeddNavRail(active = Section.Notes, onNavigate = onNavigate, onSettingsClick = onSettings)
        // Trois colonnes séparées par des filets : les carnets, la liste, la page.
        // Les filets entre les colonnes sont les poignées : on y règle leur largeur.
        org.teddapp.project.ui.TeddSidePane(
            spec = BOOKS_PANE,
            title = "les carnets",
            collapsedContent = { expand ->
                org.teddapp.project.ui.TeddPaneRail(
                    expand = expand,
                    title = "les carnets",
                    items = buildList {
                        add(org.teddapp.project.ui.PaneRailItem("all", "Toutes les notes", "notes", model.filter is NotesFilter.All) { model.filter = NotesFilter.All })
                        add(org.teddapp.project.ui.PaneRailItem("pinned", "Épinglées", "pin", model.filter is NotesFilter.Pinned) { model.filter = NotesFilter.Pinned })
                        add(org.teddapp.project.ui.PaneRailItem("favorites", "Favoris", "star", model.filter is NotesFilter.Favorites) { model.filter = NotesFilter.Favorites })
                        model.roots.forEach { book ->
                            add(org.teddapp.project.ui.PaneRailItem(book.id, book.name, book.icon, (model.filter as? NotesFilter.Book)?.id == book.id) { model.filter = NotesFilter.Book(book.id) })
                        }
                        add(org.teddapp.project.ui.PaneRailItem("trash", "Corbeille", "trash", model.inTrash) { model.filter = NotesFilter.Trash })
                    },
                )
            },
        ) {
            Column(
                modifier = Modifier.fillMaxSize().verticalScroll(rememberScrollState()),
                verticalArrangement = Arrangement.spacedBy(2.dp),
            ) {
                BooksColumn(model)
            }
        }
        org.teddapp.project.ui.TeddSidePane(spec = NOTES_LIST_PANE, title = "la liste des notes", icon = "list") {
            Column(
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.spacedBy(TeddSpace.S3),
            ) {
                org.teddapp.project.ui.RecompositionProbe("notes.list")
                NotesListHeader(model)
                // Paresseuse : trois cents notes ne se composent pas toutes pour en voir vingt.
                val visible = model.visible
                val selectedId = model.selected?.id
                androidx.compose.foundation.lazy.LazyColumn(
                    modifier = Modifier.fillMaxHeight(),
                    verticalArrangement = Arrangement.spacedBy(2.dp),
                ) {
                    items(visible.size, key = { visible[it].id }) { i ->
                        val note = visible[i]
                        NoteRow(note, model, selected = note.id == selectedId) { model.select(note.id) }
                    }
                    if (visible.isEmpty()) item { NotesEmptyLine() }
                }
            }
        }
        Column(modifier = Modifier.weight(1f).fillMaxHeight()) {
            val note = model.selected
            if (note == null) {
                if (model.inTrash) TrashEmpty() else NotesEmpty(onCreate = model::newNote)
            } else {
                val draft = if (model.inTrash) null else rememberNoteDraft(note, model)
                // En écriture, la barre reste en haut de la page, hors de ce qui défile.
                if (draft?.writing == true) {
                    Box(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = TeddSpace.S4, vertical = TeddSpace.S2),
                        contentAlignment = Alignment.TopCenter,
                    ) {
                        NoteFormatBar(
                            draft.body,
                            Modifier.widthIn(max = TeddSize.Measure),
                            onDraw = if (NoteLock.isLocked(note.body)) null else ({ model.startDrawing(note, draft.body) }),
                            onImage = if (NoteLock.isLocked(note.body)) null else ({ model.addImage(note, draft.body) }),
                            linkTitles = { q -> NoteLinks.suggest(model.titles, q, exclude = note.title) },
                        )
                    }
                    Box(Modifier.fillMaxWidth().height(1.dp).background(TeddTokens.Line))
                }
                Box(
                    modifier = Modifier.fillMaxSize().verticalScroll(rememberScrollState())
                        .padding(horizontal = TeddSpace.S8, vertical = TeddSpace.S6),
                    contentAlignment = Alignment.TopCenter,
                ) {
                    // Une ligne qui traverse un écran large ne se lit pas : la page est
                    // bornée à la mesure de lecture.
                    Box(modifier = Modifier.widthIn(max = TeddSize.Measure)) {
                        if (draft == null) TrashedNote(note, model)
                        else NoteEditor(note, model, draft, onOpenMindMap = { NavIntent.openMindMap(it); onNavigate(Section.MindMaps) })
                    }
                }
            }
        }
    }
}

@Composable
private fun NotesCompact(model: NotesModel, onNavigate: (Section) -> Unit) {
    var opened by remember { mutableStateOf<String?>(null) }
    val note = opened?.let { id -> model.visible.firstOrNull { it.id == id } }
    val draft = note?.takeIf { !model.inTrash }?.let { rememberNoteDraft(it, model) }
    // Un lien suivi demande d'ouvrir une autre note : le téléphone la montre.
    LaunchedEffect(model.openRequest) {
        model.openRequest?.let { opened = it; model.openRequest = null }
    }
    // « Écrire » crée la note puis l'ouvre : la création n'est pas immédiate, on attend qu'elle paraisse.
    var before by remember { mutableStateOf<Set<String>?>(null) }
    LaunchedEffect(model.visible.size, before) {
        val known = before ?: return@LaunchedEffect
        model.visible.firstOrNull { it.id !in known }?.let { fresh -> opened = fresh.id; before = null }
    }

    Box(modifier = Modifier.fillMaxSize()) {
    Column(modifier = Modifier.fillMaxSize().background(TeddTokens.Bg).statusBarsPadding()) {
        if (note == null) {
            Column(
                modifier = Modifier.weight(1f).verticalScroll(rememberScrollState())
                    .padding(horizontal = 16.dp, vertical = 14.dp),
                verticalArrangement = Arrangement.spacedBy(TeddSpace.S3),
            ) {
                Row(verticalAlignment = Alignment.Bottom) {
                    Text("Notes", style = TeddType.Title1, color = TeddTokens.Ink, modifier = Modifier.weight(1f))
                    Text(
                        text = "${model.visible.size} note${if (model.visible.size > 1) "s" else ""}",
                        style = TeddType.MonoSm,
                        color = TeddTokens.InkMuted,
                        modifier = Modifier.padding(bottom = 6.dp),
                    )
                    if (!model.inTrash) NotesSortButton(model)
                    if (!model.inTrash && model.canImport) NotesImportButton(model)
                }
                org.teddapp.project.ui.TeddSearchField(model.search, { model.search = it }, "Chercher dans les notes")
                BooksRow(model)
                // Les épinglées d'abord, sous leur titre : ce sont celles qu'on vient chercher.
                val pinned = model.visible.filter { it.is_pinned == 1L }
                val others = model.visible.filter { it.is_pinned != 1L }
                val split = model.filter !is NotesFilter.Pinned && pinned.isNotEmpty() && others.isNotEmpty()
                if (split) NotesGroupTitle("Épinglées")
                pinned.forEach { n -> NoteRow(n, model, selected = false, card = true) { opened = n.id } }
                if (split) NotesGroupTitle("Les autres")
                others.forEach { n -> NoteRow(n, model, selected = false, card = true) { opened = n.id } }
                if (model.inTrash && model.visible.isNotEmpty()) {
                    TeddButton(
                        text = "Vider la corbeille",
                        onClick = { model.confirmEmptyTrash = true },
                        kind = TeddButtonKind.Ghost,
                        size = TeddButtonSize.Sm,
                        icon = "trash",
                    )
                }
                if (model.visible.isEmpty()) {
                    TeddEmptyState(
                        title = when {
                            model.search.isNotBlank() -> "Aucune note ne correspond"
                            model.inTrash -> "La corbeille est vide"
                            else -> "Aucune note ici"
                        },
                        message = when {
                            model.search.isNotBlank() -> null
                            model.inTrash -> "Une note supprimée y reste 30 jours avant de disparaître."
                            else -> "Touche le bouton en bas à droite pour écrire la première."
                        },
                        icon = "notes",
                        modifier = Modifier.padding(top = TeddSpace.S6),
                    )
                }
                Spacer(Modifier.height(72.dp))
            }
        } else {
            Column(
                modifier = Modifier.weight(1f).verticalScroll(rememberScrollState())
                    .padding(horizontal = 16.dp, vertical = 10.dp),
                verticalArrangement = Arrangement.spacedBy(TeddSpace.S2),
            ) {
                TeddButton(text = "Notes", onClick = { opened = null }, kind = TeddButtonKind.Ghost, size = TeddButtonSize.Sm, icon = "chevron-left")
                if (draft == null) TrashedNote(note, model, compact = true)
                else NoteEditor(note, model, draft, compact = true, onOpenMindMap = { NavIntent.openMindMap(it); onNavigate(Section.MindMaps) })
            }
        }
        if (draft?.writing == true) {
            // En écriture, la barre de mise en forme prend la place de la navigation et
            // monte avec le clavier : elle reste sous le pouce pendant qu'on tape.
            Box(Modifier.fillMaxWidth().height(1.dp).background(TeddTokens.Line))
            NoteFormatBar(
                draft.body,
                compact = true,
                onDraw = if (note == null || NoteLock.isLocked(note.body)) null else ({ model.startDrawing(note, draft.body) }),
                onImage = if (note == null || NoteLock.isLocked(note.body)) null else ({ model.addImage(note, draft.body) }),
                linkTitles = { q -> NoteLinks.suggest(model.titles, q, exclude = note?.title) },
                modifier = Modifier
                    .background(TeddTokens.Surface)
                    .windowInsetsPadding(WindowInsets.ime.union(WindowInsets.navigationBars))
                    .padding(vertical = 4.dp),
            )
        } else {
            TeddBottomNav(active = Section.Notes, onNavigate = onNavigate, modifier = Modifier.navigationBarsPadding())
        }
    }
        // Écrire : le geste principal, sous le pouce.
        if (note == null && !model.inTrash) {
            org.teddapp.project.ui.TeddFab(
                icon = "edit",
                onClick = { before = model.visible.map { it.id }.toSet(); model.newNote() },
                modifier = Modifier.align(Alignment.BottomEnd).navigationBarsPadding().padding(end = 20.dp, bottom = 88.dp),
            )
        }
    }
}

@Composable
private fun NotesGroupTitle(text: String) {
    Text(text.uppercase(), style = TeddType.Overline, color = TeddTokens.InkMuted, modifier = Modifier.padding(start = TeddSpace.S1, top = TeddSpace.S2))
}

/** Les carnets, en colonne sur grand écran. */
@Composable
private fun BooksColumn(model: NotesModel) {
    Text("VUES", style = TeddType.Overline, color = TeddTokens.InkMuted, modifier = Modifier.padding(start = TeddSpace.S1, bottom = TeddSpace.S2))
    BookEntry("Toutes les notes", model.notes.count { it.is_deleted == 0L }, model.filter is NotesFilter.All) {
        model.filter = NotesFilter.All
    }
    BookEntry("Épinglées", model.notes.count { it.is_deleted == 0L && it.is_pinned == 1L }, model.filter is NotesFilter.Pinned, icon = "pin") {
        model.filter = NotesFilter.Pinned
    }
    BookEntry("Favoris", model.notes.count { it.is_deleted == 0L && it.is_favorite == 1L }, model.filter is NotesFilter.Favorites, icon = "star") {
        model.filter = NotesFilter.Favorites
    }
    Row(
        modifier = Modifier.padding(start = TeddSpace.S1, top = TeddSpace.S4, bottom = TeddSpace.S1),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Text("CARNETS", style = TeddType.Overline, color = TeddTokens.InkMuted, modifier = Modifier.weight(1f))
        TeddIconButton(onClick = { model.creatingUnder = null; model.creatingBook = true }, size = 28.dp) {
            TeddIcon(name = "plus", size = 16.dp, color = TeddTokens.InkMuted)
        }
    }
    if (model.roots.isEmpty()) {
        Text(
            "Aucun carnet. Crée-en un pour ranger tes notes.",
            modifier = Modifier.padding(horizontal = TeddSpace.S1),
            color = TeddTokens.InkMuted,
            style = TeddType.Caption,
        )
    }
    model.roots.forEach { book -> BookBranch(book, model, depth = 0) }
    val tags = model.tags
    if (tags.isNotEmpty()) {
        Text(
            "ÉTIQUETTES",
            style = TeddType.Overline,
            color = TeddTokens.InkMuted,
            modifier = Modifier.padding(start = TeddSpace.S1, top = TeddSpace.S4, bottom = TeddSpace.S2),
        )
        tags.forEach { (tag, n) ->
            BookEntry("#$tag", n, model.filter == NotesFilter.Tag(tag), icon = "category") {
                model.filter = NotesFilter.Tag(tag)
            }
        }
    }
    Spacer(Modifier.height(TeddSpace.S4))
    BookEntry("Corbeille", model.trash.size, model.inTrash, icon = "trash") {
        model.filter = NotesFilter.Trash
    }
    if (model.canImport) {
        // Une action plutôt qu'une vue : pas de compte, juste le geste.
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(TeddTokens.RSm))
                .clickable(onClick = model::importMarkdown)
                .height(36.dp)
                .padding(horizontal = 6.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(4.dp),
        ) {
            Box(Modifier.size(22.dp), contentAlignment = Alignment.Center) {
                TeddIcon(name = "arrow-down", size = 15.dp, color = TeddTokens.InkSubtle)
            }
            Text(
                "Importer une note (.md)",
                modifier = Modifier.padding(start = 4.dp),
                color = TeddTokens.InkMuted,
                style = TeddType.Label.copy(fontSize = 14.sp, fontWeight = FontWeight(400)),
            )
        }
    }
}

/**
 * Un dossier et sa descendance. Le chevron n'apparaît que s'il y a quelque chose
 * dessous : un dossier vide ne doit pas promettre un pli qui ne s'ouvre pas.
 */
@Composable
private fun BookBranch(book: com.tedd.db.Notebook, model: NotesModel, depth: Int) {
    val enfants = model.childrenOf(book.id)
    val ouvert = book.id in model.expanded
    val actif = (model.filter as? NotesFilter.Book)?.id == book.id

    BookEntry(
        name = book.name,
        count = model.countIn(book.id),
        active = actif,
        depth = depth,
        expandable = enfants.isNotEmpty(),
        expanded = ouvert,
        onToggle = { model.toggleExpanded(book.id) },
        onLongPress = { model.renamingBook = book },
        icon = book.icon,
        tint = noteColor(book.color),
        tree = model.hasNested,
    ) { model.filter = NotesFilter.Book(book.id) }

    if (ouvert) {
        enfants.forEach { enfant -> BookBranch(enfant, model, depth + 1) }
    }
}

/** Les mêmes carnets, en bandeau défilant sur téléphone. */
@Composable
private fun BooksRow(model: NotesModel) {
    Row(
        modifier = Modifier.fillMaxWidth().horizontalScroll(rememberScrollState()),
        horizontalArrangement = Arrangement.spacedBy(6.dp),
    ) {
        BookChip("Toutes", model.filter is NotesFilter.All) { model.filter = NotesFilter.All }
        BookChip("Épinglées", model.filter is NotesFilter.Pinned) { model.filter = NotesFilter.Pinned }
        BookChip("Favoris", model.filter is NotesFilter.Favorites) { model.filter = NotesFilter.Favorites }
        val ouvert = (model.filter as? NotesFilter.Book)?.id
        model.roots.forEach { book ->
            BookChip("${book.name} · ${model.countIn(book.id)}", ouvert == book.id) {
                model.filter = NotesFilter.Book(book.id)
            }
        }
        // Faute de place pour un arbre, les sous-dossiers du dossier ouvert
        // s'ajoutent à la suite, précédés d'un chevron.
        ouvert?.let { id -> model.childrenOf(id) }?.forEach { enfant ->
            BookChip("› ${enfant.name} · ${model.countIn(enfant.id)}", false) {
                model.filter = NotesFilter.Book(enfant.id)
            }
        }
        model.tags.forEach { (tag, n) ->
            BookChip("#$tag · $n", model.filter == NotesFilter.Tag(tag)) { model.filter = NotesFilter.Tag(tag) }
        }
        BookChip(if (model.trash.isEmpty()) "Corbeille" else "Corbeille · ${model.trash.size}", model.inTrash) {
            model.filter = NotesFilter.Trash
        }
    }
}

@Composable
private fun BookChip(label: String, active: Boolean, onClick: () -> Unit) {
    org.teddapp.project.ui.TeddFilterChip(label = label, selected = active, onClick = onClick)
}

@Composable
private fun BookEntry(
    name: String,
    count: Int,
    active: Boolean,
    depth: Int = 0,
    expandable: Boolean = false,
    expanded: Boolean = false,
    onToggle: (() -> Unit)? = null,
    onLongPress: (() -> Unit)? = null,
    icon: String = "notes",
    tint: Color? = null,
    tree: Boolean = false,
    onClick: () -> Unit,
) {
    val shape = RoundedCornerShape(TeddTokens.RSm)
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .then(if (active) Modifier.teddCardShadow(shape) else Modifier)
            .teddClickable(
                onClick = onClick,
                shape = shape,
                fill = if (active) TeddTokens.Surface else Color.Transparent,
                hover = if (active) TeddTokens.Surface else TeddTokens.SurfaceSunken,
                role = null,
            )
            .height(36.dp)
            .padding(start = (6 + depth * 16).dp, end = 6.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(4.dp),
    ) {
        // Le chevron n'ouvre pas le dossier : il le déplie. Deux gestes différents,
        // deux zones différentes.
        // Dans l'arbre des carnets, la place du chevron est toujours gardée : les noms
        // restent alignés, qu'un dossier ait des sous-dossiers ou non.
        if (expandable && onToggle != null) {
            TeddIconButton(onClick = onToggle, size = 22.dp) {
                TeddIcon(name = if (expanded) "chevron-down" else "chevron-right", size = 14.dp, color = TeddTokens.InkMuted)
            }
        } else if (tree) {
            Spacer(Modifier.width(22.dp))
        }
        Box(Modifier.size(if (tree) 18.dp else 22.dp), contentAlignment = Alignment.Center) {
            TeddIcon(name = icon, size = 15.dp, color = tint ?: if (active) TeddTokens.ModNotes else TeddTokens.InkSubtle)
        }
        Text(
            text = name,
            modifier = Modifier.weight(1f).padding(start = 4.dp),
            color = if (active) TeddTokens.Ink else TeddTokens.InkMuted,
            style = TeddType.Label.copy(fontSize = 14.sp, fontWeight = FontWeight(if (active) 540 else 400)),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
        )
        if (active && onLongPress != null) {
            TeddIconButton(onClick = onLongPress, size = 26.dp) {
                TeddIcon(name = "more", size = 16.dp, color = TeddTokens.InkMuted, strokeWidth = 3.dp)
            }
        } else {
            Text("$count", style = TeddType.MonoSm.copy(fontSize = 11.sp), color = TeddTokens.InkMuted, modifier = Modifier.padding(end = 4.dp))
        }
    }
}

@Composable
private fun NotesListHeader(model: NotesModel) {
    Column(verticalArrangement = Arrangement.spacedBy(TeddSpace.S3)) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(
                text = when (val f = model.filter) {
                    NotesFilter.All -> "Toutes les notes"
                    NotesFilter.Pinned -> "Épinglées"
                    NotesFilter.Favorites -> "Favoris"
                    NotesFilter.Trash -> "Corbeille"
                    is NotesFilter.Tag -> "#${f.name}"
                    is NotesFilter.Book -> model.bookName(f.id) ?: "Carnet"
                },
                style = TeddType.Title2,
                color = TeddTokens.Ink,
                modifier = Modifier.weight(1f),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
            if (!model.inTrash) NotesSortButton(model)
            if (!model.inTrash) {
                TeddButton(text = "Écrire", onClick = model::newNote, kind = TeddButtonKind.Primary, size = TeddButtonSize.Sm, icon = "edit")
            } else if (model.trash.isNotEmpty()) {
                TeddButton(text = "Vider", onClick = { model.confirmEmptyTrash = true }, kind = TeddButtonKind.Ghost, size = TeddButtonSize.Sm, icon = "trash")
            }
        }
        InlineField(value = model.search, placeholder = "Chercher dans les notes", onChange = { model.search = it }, icon = "search")
    }
}

@Composable
private fun NoteRow(note: Note, model: NotesModel, selected: Boolean, card: Boolean = false, onClick: () -> Unit) {
    // Une liste de notes est une liste, pas une pile de cartes : celle qu'on lit se
    // pose sur la surface, les autres restent sur le papier. On en voit deux fois plus.
    val shape = RoundedCornerShape(TeddTokens.RMd)
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .then(if (selected) Modifier.teddCardShadow(shape) else Modifier)
            // Sur téléphone, chaque note est une carte : une cible franche pour le pouce.
            .then(if (card) Modifier.border(1.dp, TeddTokens.Line, shape) else Modifier)
            .teddClickable(
                onClick = onClick,
                shape = shape,
                fill = if (selected || card) TeddTokens.Surface else Color.Transparent,
                hover = if (selected || card) TeddTokens.Surface else TeddTokens.SurfaceSunken,
                role = null,
            )
            .padding(horizontal = if (card) TeddSpace.S4 else TeddSpace.S3, vertical = if (card) TeddSpace.S3 else 10.dp),
        verticalArrangement = Arrangement.spacedBy(if (card) 4.dp else 2.dp),
    ) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
            noteColor(note.color)?.let { ColorDot(it) }
            Text(
                text = note.title.orEmpty().ifBlank { "Sans titre" },
                color = TeddTokens.Ink,
                style = TeddType.BodyStrong,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier.weight(1f),
            )
            if (note.attachments?.contains("\"ink\"") == true) TeddIcon(name = "draw", size = 13.dp, color = TeddTokens.InkMuted)
            if (note.body.contains("](file:")) TeddIcon(name = "image", size = 13.dp, color = TeddTokens.InkMuted)
            if (NoteLock.isLocked(note.body)) TeddIcon(name = "lock", size = 13.dp, color = TeddTokens.InkMuted)
            if (note.is_favorite == 1L) TeddIcon(name = "star", size = 13.dp, color = TeddTokens.ModNotes)
            if (note.is_pinned == 1L) TeddIcon(name = "pin", size = 13.dp, color = TeddTokens.ModNotes)
        }
        // L'extrait montre le texte, pas les signes Markdown qui le mettent en forme.
        val verrouillee = NoteLock.isLocked(note.body)
        val extrait = if (verrouillee) "Note verrouillée" else MarkdownEdits.plain(note.body)
        if (extrait.isNotEmpty()) {
            Text(
                text = extrait.take(if (card) 220 else 110),
                color = TeddTokens.InkMuted,
                style = if (card) TeddType.Body else TeddType.Caption,
                maxLines = if (card) 3 else 2,
                overflow = TextOverflow.Ellipsis,
            )
        }
        val jour = TeddDates.formatShort(TeddDates.isoFromDays((note.updated_at / 86_400_000L).toInt())) ?: ""
        val carnet = model.bookName(note.parent_id)
        val etiquettes = parseTags(note.tags)
        if (card) {
            // Pied de carte : le carnet et deux étiquettes, la date à droite.
            Row(
                modifier = Modifier.fillMaxWidth().padding(top = TeddSpace.S1),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(6.dp),
            ) {
                if (carnet != null) org.teddapp.project.ui.TeddTag(carnet, icon = model.book(note.parent_id)?.icon ?: "notes")
                etiquettes.take(2).forEach { org.teddapp.project.ui.TeddTag("#$it") }
                Spacer(Modifier.weight(1f))
                Text(jour, style = TeddType.MonoSm.copy(fontSize = 11.sp), color = TeddTokens.InkMuted)
            }
        } else {
            Text(
                text = listOfNotNull(jour, carnet).joinToString(" · ") +
                    etiquettes.take(3).joinToString("") { "  #$it" },
                style = TeddType.MonoSm.copy(fontSize = 11.sp),
                color = TeddTokens.InkMuted,
                modifier = Modifier.padding(top = 2.dp),
            )
        }
    }
}

/** La note ouverte : titre, corps, et les trois gestes qui comptent. */
@Composable
private fun NoteEditor(
    note: Note,
    model: NotesModel,
    draft: NoteDraft,
    compact: Boolean = false,
    onOpenMindMap: ((String) -> Unit)? = null,
) {
    val body = draft.body
    var history by remember(note.id) { mutableStateOf(false) }
    if (history) NoteHistoryDialog(model.db, note, draft, onClose = { history = false })
    // Verrou : une note chiffrée reste fermée tant qu'on ne l'a pas ouverte, et se
    // referme dès qu'on la quitte.
    val locked = NoteLock.isLocked(note.body)
    val closed = locked && model.unlocked[note.id] == null
    var locking by remember(note.id) { mutableStateOf(false) }
    if (locking) LockNoteDialog(model, note, draft, onClose = { locking = false })
    androidx.compose.runtime.DisposableEffect(note.id) { onDispose { model.relock(note.id) } }
    @Suppress("DEPRECATION")
    val clipboard = androidx.compose.ui.platform.LocalClipboardManager.current
    // Une note vide qu'on ouvre, c'est une note qu'on vient de créer : le curseur va dans
    // le titre. Sans ça, le bouton « Écrire » garde la main et l'espace en recrée une.
    val titleFocus = remember { androidx.compose.ui.focus.FocusRequester() }
    LaunchedEffect(note.id) {
        if (note.title.isNullOrEmpty() && note.body.isEmpty()) runCatching { titleFocus.requestFocus() }
    }

    Column(modifier = Modifier.fillMaxWidth()) {
        // Au-dessus du titre : où la note est rangée, puis les deux gestes de tous les jours
        // (lire ou écrire, épingler). Ranger ailleurs et supprimer sont dans le menu.
        Row(
            modifier = Modifier.fillMaxWidth().padding(bottom = TeddSpace.S3),
            horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            // Une note écrite dans un nœud de carte heuristique dit sa carte ; un tap y mène.
            val carte = model.mindMapOf(note)
            TeddIcon(name = if (carte != null) "mindmap" else "notes", size = 14.dp, color = TeddTokens.ModNotes)
            Text(
                text = carte?.let { "Carte : ${it.title}" } ?: model.bookName(note.parent_id) ?: "Sans carnet",
                style = TeddType.Caption,
                color = if (carte != null && onOpenMindMap != null) TeddTokens.Link else TeddTokens.InkMuted,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier.weight(1f).let { m -> if (carte != null && onOpenMindMap != null) m.clickable { onOpenMindMap(carte.id) } else m },
            )
            if (locked) TeddIcon(name = "lock", size = 14.dp, color = TeddTokens.InkMuted)
            if (!compact) TeddVisibilityBadge(TeddVisibility.Private)
            if (!closed) TeddTabs(
                tabs = listOf(
                    TeddTab("read", "Lire", icon = if (compact) null else "eye"),
                    TeddTab("write", "Écrire", icon = if (compact) null else "edit"),
                ),
                selected = if (draft.writing) "write" else "read",
                onSelect = { draft.writing = it == "write" },
            )
            TeddIconButton(onClick = { model.togglePin(note) }, active = note.is_pinned == 1L) {
                TeddIcon(name = "pin", size = 16.dp, color = if (note.is_pinned == 1L) TeddTokens.Ink else TeddTokens.InkMuted)
            }
            TeddIconButton(onClick = { model.toggleFavorite(note) }, active = note.is_favorite == 1L) {
                TeddIcon(name = "star", size = 16.dp, color = if (note.is_favorite == 1L) TeddTokens.Ink else TeddTokens.InkMuted)
            }
            NoteColorButton(note, model)
            ProjectMoreMenu(
                model.bookPaths().filter { (book, _) -> book.id != note.parent_id }.map { (book, path) ->
                    MenuAction("Ranger dans $path", "notes", { model.moveTo(note, book.id) })
                } + listOfNotNull(
                    if (note.parent_id != null) MenuAction("Sortir du carnet", "arrow-right", { model.moveTo(note, null) }) else null,
                    if (!locked && NoteLock.available) MenuAction("Verrouiller la note", "lock", { locking = true }) else null,
                    if (locked && !closed) MenuAction("Retirer le verrou", "lock", { model.removeLock(note, draft.title, body.text.toString()) }) else null,
                ) + if (locked) emptyList() else listOf(
                    MenuAction("Ajouter un dessin", "draw", {
                        // Au bout du texte, sur sa propre ligne.
                        body.edit { selection = androidx.compose.ui.text.TextRange(length) }
                        model.startDrawing(note, body)
                    }),
                    MenuAction("Ajouter une image", "image", {
                        body.edit { selection = androidx.compose.ui.text.TextRange(length) }
                        model.addImage(note, body)
                    }),
                    MenuAction("Historique des versions", "clock", { history = true }),
                    MenuAction("Dupliquer", "copy", { model.duplicate(note) }),
                    MenuAction("Exporter en Markdown", "share", { model.exportMarkdown(note) { clipboard.setText(androidx.compose.ui.text.AnnotatedString(it)) } }),
                ) + listOfNotNull(
                    if (model.canExportPdf && !locked) MenuAction("Exporter en PDF", "print", { model.exportPdf(note) }) else null,
                ) + listOf(
                    MenuAction("Supprimer la note", "trash", { model.confirmDelete = note }, danger = true),
                ),
            )
        }
        BasicTextField(
            value = draft.title,
            onValueChange = { draft.title = it },
            // Un titre long passe à la ligne plutôt que de filer hors de l'écran.
            textStyle = (if (compact) TeddType.Title2 else TeddType.Title1).copy(color = TeddTokens.Ink),
            cursorBrush = SolidColor(TeddTokens.Ink),
            modifier = Modifier.fillMaxWidth().focusRequester(titleFocus),
            decorationBox = { inner ->
                if (draft.title.isEmpty()) Text("Titre", style = if (compact) TeddType.Title2 else TeddType.Title1, color = TeddTokens.InkSubtle)
                inner()
            },
        )

        // Ce qu'on a écrit, dit sobrement : c'est la seule mesure utile d'une note.
        Text(
            text = buildString {
                val mots = MarkdownEdits.plain(body.text.toString()).split(' ').count { it.isNotEmpty() }
                if (compact) append("Privée · ")
                if (closed) append("verrouillée") else append(if (mots <= 1) "$mots mot" else "$mots mots")
                append(" · modifiée le ")
                append(TeddDates.formatShort(TeddDates.isoFromDays((note.updated_at / 86_400_000L).toInt())) ?: "")
            },
            style = TeddType.MonoSm,
            color = TeddTokens.InkMuted,
            modifier = Modifier.padding(top = TeddSpace.S2, bottom = TeddSpace.S3),
        )
        Box(Modifier.padding(bottom = TeddSpace.S6)) { NoteTags(note, model) }

        // La page : le texte posé sur le papier, à la mesure de lecture, sans cadre.
        Box(modifier = Modifier.fillMaxWidth()) {
            if (closed) {
                LockedNoteBody(model, note)
            } else if (draft.writing) {
                BasicTextField(
                    state = body,
                    // Entrée dans une liste appelle l'élément suivant.
                    inputTransformation = ListContinuation,
                    textStyle = TeddType.BodyLg.copy(color = TeddTokens.Ink),
                    cursorBrush = SolidColor(TeddTokens.Ink),
                    modifier = Modifier.fillMaxWidth().heightIn(min = 360.dp).markdownShortcuts(body),
                    decorator = { inner ->
                        if (body.text.isEmpty()) {
                            Text(
                                text = "Écris ici, la barre met en forme. " +
                                    "Rien à enregistrer, c'est déjà fait.",
                                style = TeddType.BodyLg,
                                color = TeddTokens.InkSubtle,
                            )
                        }
                        inner()
                    },
                )
            } else {
                // En lecture, le Markdown est rendu : les titres, listes et emphases
                // qu'on a écrits se voient enfin au lieu de rester en signes. Les cases se
                // cochent d'un tap, sans repasser en écriture.
                NoteReading(
                    text = body.text.toString(),
                    attachments = note.attachments,
                    onToggleTask = { offset -> body.format { t, s, e -> MdEdit(MarkdownEdits.toggleTaskAt(t, offset), s, e) } },
                    onOpenInk = { id -> model.openDrawing(note, id, body) },
                    db = model.db,
                    onOpenFile = { id -> model.viewing = Triple(note.id, id, body) },
                    links = NoteLinkActions(exists = { model.noteTitled(it) != null }, open = model::followLink),
                )
            }
        }
        NoteBacklinks(model.backlinks(note), onOpen = model::openNote)
    }
}

/**
 * La note en lecture : le texte rendu, et les dessins à leur place. Le texte est coupé
 * autour de chaque ligne de dessin ; chaque morceau garde sa position dans la note, pour
 * qu'une case cochée change le bon caractère.
 */
@Composable
private fun NoteReading(
    text: String,
    attachments: String?,
    onToggleTask: ((Int) -> Unit)?,
    onOpenInk: ((String) -> Unit)?,
    db: com.tedd.db.TeddDatabase? = null,
    onOpenFile: ((String) -> Unit)? = null,
    links: NoteLinkActions? = null,
) {
    val inks = remember(attachments) { org.teddapp.project.ui.notes.ink.NoteAttachments.inks(attachments) }
    val parts = remember(text) { readingParts(text) }
    if (parts.none { it is ReadingPart.Ink || it is ReadingPart.File }) {
        NoteMarkdown(text, links = links, onToggleTask = onToggleTask)
        return
    }
    Column(verticalArrangement = Arrangement.spacedBy(TeddSpace.S3), modifier = Modifier.heightIn(min = 360.dp)) {
        parts.forEach { part ->
            when (part) {
                is ReadingPart.Text -> if (part.text.isNotBlank()) {
                    NoteMarkdown(part.text, minHeight = false, links = links, onToggleTask = onToggleTask?.let { t -> { offset -> t(part.start + offset) } })
                }
                is ReadingPart.File -> if (db != null) {
                    NoteImage(db, part.id, onOpen = onOpenFile?.let { open -> { open(part.id) } })
                }
                is ReadingPart.Ink -> {
                    val drawing = remember(inks[part.id]) { inks[part.id]?.let { org.teddapp.project.ui.notes.ink.InkCodec.decode(it) } }
                    if (drawing != null) {
                        org.teddapp.project.ui.notes.ink.InkView(
                            drawing,
                            if (onOpenInk != null) Modifier.clickable { onOpenInk(part.id) } else Modifier,
                        )
                    } else {
                        // Pas encore arrivé d'un autre appareil, ou vide : une place qu'on peut toucher pour dessiner.
                        Box(
                            Modifier.fillMaxWidth().height(96.dp)
                                .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RMd))
                                .let { m -> if (onOpenInk != null) m.clickable { onOpenInk(part.id) } else m },
                            contentAlignment = Alignment.Center,
                        ) {
                            Text("Dessin vide · toucher pour dessiner", style = TeddType.Caption, color = TeddTokens.InkMuted)
                        }
                    }
                }
            }
        }
    }
}

private sealed interface ReadingPart {
    class Text(val text: String, val start: Int) : ReadingPart
    class Ink(val id: String) : ReadingPart
    class File(val id: String) : ReadingPart
}

private fun readingParts(text: String): List<ReadingPart> {
    val parts = mutableListOf<ReadingPart>()
    var chunkStart = 0
    var lineStart = 0
    while (lineStart <= text.length) {
        val end = text.indexOf('\n', lineStart).let { if (it < 0) text.length else it }
        val line = text.substring(lineStart, end)
        val block: ReadingPart? = MarkdownEdits.inkIdOf(line)?.let { ReadingPart.Ink(it) }
            ?: MarkdownEdits.fileIdOf(line)?.let { ReadingPart.File(it) }
        if (block != null) {
            if (lineStart > chunkStart) parts += ReadingPart.Text(text.substring(chunkStart, lineStart), chunkStart)
            parts += block
            chunkStart = minOf(end + 1, text.length)
        }
        lineStart = end + 1
    }
    if (chunkStart < text.length) parts += ReadingPart.Text(text.substring(chunkStart), chunkStart)
    return parts
}

@Composable
private fun NoteMarkdown(
    body: String,
    minHeight: Boolean = true,
    links: NoteLinkActions? = null,
    onToggleTask: ((Int) -> Unit)? = null,
) {
    // Un vrai coup de surligneur : assez franc pour sauter aux yeux, assez clair pour
    // qu'on lise dessous, dans les deux thèmes.
    val fill = TeddTokens.Warning.copy(alpha = 0.32f)
    // Les gestes des liens changent d'une composition à l'autre ; l'annotateur, lui, reste.
    val actions = remember { LinkHolder() }
    actions.current = links
    val linkColor = TeddTokens.Link
    val missingColor = TeddTokens.InkMuted
    val annotator = remember(fill, linkColor, missingColor) { noteAnnotator(fill, linkColor, missingColor, actions) }
    Markdown(
        content = body,
        annotator = annotator,
        components = markdownComponents(
            checkbox = { m ->
                MarkdownCheckBox(m.content, m.node, m.typography.text, checkedIndicator = { checked, mod ->
                    TaskBox(checked, mod, onToggle = onToggleTask?.let { toggle -> { toggle(m.node.startOffset) } })
                })
            },
        ),
        colors = markdownColor(text = TeddTokens.Ink),
        typography = markdownTypography(
            h1 = TeddType.Title1,
            h2 = TeddType.Title2,
            h3 = TeddType.Heading,
            text = TeddType.BodyLg,
            paragraph = TeddType.BodyLg,
            ordered = TeddType.BodyLg,
            bullet = TeddType.BodyLg,
            list = TeddType.BodyLg,
            quote = TeddType.Quote,
        ),
        modifier = Modifier.fillMaxWidth().let { if (minHeight) it.heightIn(min = 360.dp) else it },
    )
}

/**
 * Le surligné, `==comme ceci==`. Le Markdown standard ne le connaît pas : on le
 * reconnaît dans les morceaux de texte d'un paragraphe, pris dans l'ordre. Un `==`
 * collé au mot qui suit ouvre, collé au mot qui précède ferme ; isolé entre deux
 * espaces (« a == b »), il reste tel quel.
 */
private fun noteAnnotator(fill: Color, linkColor: Color, missingColor: Color, links: LinkHolder): MarkdownAnnotator {
    var current: AnnotatedString.Builder? = null
    var open = false
    // Les liens `[[…]]` du texte, par position : calculés une fois par texte.
    var rangesOf: String? = null
    var starts = emptySet<Int>()
    var ends = emptySet<Int>()
    return markdownAnnotator { content, child ->
        // Un nouveau paragraphe, c'est un nouveau texte : rien n'y est encore ouvert.
        if (current !== this) { current = this; open = false }
        val actions = links.current
        if (actions != null) {
            if (rangesOf != content) {
                val found = NoteLinks.link.findAll(content).map { it.range }.toList()
                starts = found.mapTo(HashSet()) { it.first }
                ends = found.mapTo(HashSet()) { it.last }
                rangesOf = content
            }
            val at = child.startOffset
            when {
                // Les crochets extérieurs d'un lien ne s'affichent pas.
                child.type == MarkdownTokenTypes.LBRACKET && at in starts -> return@markdownAnnotator true
                child.type == MarkdownTokenTypes.RBRACKET && at in ends -> return@markdownAnnotator true
                child.type == org.intellij.markdown.MarkdownElementTypes.SHORT_REFERENCE_LINK && (at - 1) in starts -> {
                    val label = content.substring(child.startOffset + 1, child.endOffset - 1)
                    val exists = actions.exists(label)
                    // Une note qui existe est un lien franc ; une qui n'existe pas encore, en
                    // pointillé discret : la suivre la crée.
                    val style = androidx.compose.ui.text.TextLinkStyles(
                        SpanStyle(
                            color = if (exists) linkColor else missingColor,
                            textDecoration = androidx.compose.ui.text.style.TextDecoration.Underline,
                        ),
                    )
                    withLink(androidx.compose.ui.text.LinkAnnotation.Clickable(label, style) { links.current?.open?.invoke(label) }) {
                        append(label)
                    }
                    return@markdownAnnotator true
                }
            }
        }
        if (child.type != MarkdownTokenTypes.TEXT) return@markdownAnnotator false
        val text = child.getTextInNode(content).toString()
        if (!text.contains("==")) return@markdownAnnotator false
        var i = 0
        while (true) {
            val j = text.indexOf("==", i)
            if (j < 0) { append(text.substring(i)); break }
            append(text.substring(i, j))
            val next = text.getOrNull(j + 2)
            val prev = text.getOrNull(j - 1)
            when {
                !open && next != null && !next.isWhitespace() && next != '=' -> { pushStyle(SpanStyle(background = fill)); open = true }
                open && prev != null && !prev.isWhitespace() -> { pop(); open = false }
                else -> append("==")
            }
            i = j + 2
        }
        true
    }
}

/**
 * Les notes qui citent celle-ci : le chemin du retour. Rien quand personne ne la cite :
 * une section vide n'apprend rien.
 */
@Composable
private fun NoteBacklinks(notes: List<Note>, onOpen: (String) -> Unit) {
    if (notes.isEmpty()) return
    Column(
        modifier = Modifier.fillMaxWidth().padding(top = TeddSpace.S8),
        verticalArrangement = Arrangement.spacedBy(TeddSpace.S1),
    ) {
        Box(Modifier.fillMaxWidth().height(1.dp).background(TeddTokens.Line))
        Text(
            "MENTIONNÉE DANS",
            style = TeddType.Overline,
            color = TeddTokens.InkMuted,
            modifier = Modifier.padding(top = TeddSpace.S3, bottom = TeddSpace.S1),
        )
        notes.forEach { n ->
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(TeddTokens.RSm))
                    .clickable { onOpen(n.id) }
                    .padding(vertical = 6.dp, horizontal = 4.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
            ) {
                TeddIcon(name = "arrow-left", size = 14.dp, color = TeddTokens.InkMuted)
                Text(
                    n.title.orEmpty().ifBlank { "Sans titre" },
                    style = TeddType.Body,
                    color = TeddTokens.Link,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
            }
        }
    }
}

/** Ce que les liens `[[…]]` savent faire dans une note en lecture. */
internal class NoteLinkActions(val exists: (String) -> Boolean, val open: (String) -> Unit)

/** Le porteur des gestes des liens, stable pour l'annotateur qui le lit. */
private class LinkHolder { var current: NoteLinkActions? = null }

/** Une case de liste de tâches, assez grande pour le pouce. */
@Composable
private fun TaskBox(checked: Boolean, modifier: Modifier, onToggle: (() -> Unit)?) {
    val shape = RoundedCornerShape(4.dp)
    Box(
        modifier = modifier
            .padding(end = 6.dp)
            .size(24.dp)
            .then(if (onToggle != null) Modifier.clip(RoundedCornerShape(TeddTokens.RSm)).clickable(onClick = onToggle) else Modifier),
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier = Modifier
                .size(16.dp)
                .background(if (checked) TeddTokens.ModNotes else Color.Transparent, shape)
                .border(1.5.dp, if (checked) TeddTokens.ModNotes else TeddTokens.LineStrong, shape),
            contentAlignment = Alignment.Center,
        ) {
            if (checked) TeddIcon(name = "check", size = 12.dp, color = Color.White, strokeWidth = 2.dp)
        }
    }
}

/**
 * Une note de la corbeille : on la lit, on la restaure ou on la détruit. On ne l'écrit
 * pas : modifier ce qu'on a jeté, c'est le restaurer sans le dire.
 */
@Composable
private fun TrashedNote(note: Note, model: NotesModel, compact: Boolean = false) {
    val supprimee = note.deleted_at ?: note.updated_at
    val jours = (org.teddapp.project.db.repo.NoteRepository.TRASH_DAYS -
        (org.teddapp.project.db.nowMillis() - supprimee) / 86_400_000L).coerceAtLeast(0L)
    Column(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(bottom = TeddSpace.S3),
            horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            TeddIcon(name = "trash", size = 14.dp, color = TeddTokens.InkMuted)
            Text(
                text = buildString {
                    append("Supprimée le ")
                    append(TeddDates.formatShort(TeddDates.isoFromDays((supprimee / 86_400_000L).toInt())) ?: "")
                    append(" · ")
                    append(if (jours <= 1) "disparaît demain" else "disparaît dans $jours jours")
                },
                style = TeddType.Caption,
                color = TeddTokens.InkMuted,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier.weight(1f),
            )
        }
        Row(
            modifier = Modifier.padding(bottom = TeddSpace.S4),
            horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
        ) {
            TeddButton(text = "Restaurer", onClick = { model.restoreNote(note) }, kind = TeddButtonKind.Primary, size = TeddButtonSize.Sm, icon = "undo")
            TeddButton(
                text = if (compact) "Supprimer" else "Supprimer définitivement",
                onClick = { model.confirmForget = note },
                kind = TeddButtonKind.Ghost,
                size = TeddButtonSize.Sm,
                icon = "trash",
            )
        }
        Text(
            text = note.title.orEmpty().ifBlank { "Sans titre" },
            style = if (compact) TeddType.Title2 else TeddType.Title1,
            color = TeddTokens.InkMuted,
            modifier = Modifier.padding(bottom = TeddSpace.S6),
        )
        if (NoteLock.isLocked(note.body)) {
            Text("Note verrouillée : restaure-la pour l'ouvrir.", style = TeddType.Body, color = TeddTokens.InkMuted)
        } else {
            NoteReading(text = note.body, attachments = note.attachments, onToggleTask = null, onOpenInk = null, db = model.db)
        }
    }
}

@Composable
private fun TrashEmpty() {
    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        TeddEmptyState(
            title = "La corbeille est vide",
            message = "Une note supprimée y reste 30 jours avant de disparaître.",
            icon = "trash",
        )
    }
}

@Composable
private fun InlineField(value: String, placeholder: String, onChange: (String) -> Unit, icon: String? = null) {
    val shape = RoundedCornerShape(TeddTokens.RSm)
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(TeddSize.ControlMd)
            .background(TeddTokens.Surface, shape)
            .border(1.dp, TeddTokens.LineStrong, shape)
            .padding(horizontal = TeddSpace.S3),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
    ) {
        if (icon != null) TeddIcon(name = icon, size = 16.dp, color = TeddTokens.InkMuted)
        BasicTextField(
            value = value,
            onValueChange = onChange,
            singleLine = true,
            textStyle = TeddType.Body.copy(color = TeddTokens.Ink),
            cursorBrush = SolidColor(TeddTokens.Ink),
            modifier = Modifier.weight(1f),
            decorationBox = { inner ->
                if (value.isEmpty()) Text(placeholder, color = TeddTokens.InkSubtle, style = TeddType.Body, maxLines = 1)
                inner()
            },
        )
    }
}

@Composable
private fun NotesEmpty(onCreate: () -> Unit) {
    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        TeddEmptyState(
            title = "Aucune note ouverte",
            message = "Choisis une note dans la liste, ou commence à écrire.",
            icon = "notes",
            actionLabel = "Écrire une note",
            onAction = onCreate,
        )
    }
}

@Composable
private fun NotesEmptyLine() {
    Text(
        text = "Aucune note ici. Écris la première.",
        modifier = Modifier.padding(TeddSpace.S3),
        color = TeddTokens.InkMuted,
        style = TeddType.Body,
    )
}
